import { cn } from '@/lib/cn';

interface GoldThreadProps {
  className?: string;
  /** Width in pixels at desktop; uses width-12 utility otherwise. */
  width?: number;
  /** Vertical orientation. */
  vertical?: boolean;
}

/**
 * Decorative gold hairline — used as a section motif throughout marketing pages.
 *
 * Echoes the "fabric thread" metaphor that runs through the brand: each section
 * is connected by a single fine gold line. The line draws in on first render
 * via a CSS keyframe (see globals.css → thread-draw).
 */
export function GoldThread({ className, width = 48, vertical = false }: GoldThreadProps) {
  if (vertical) {
    return (
      <span
        aria-hidden="true"
        className={cn('block bg-gold', className)}
        style={{ width: 1, height: width }}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn('block bg-gold', className)}
      style={{ height: 1, width }}
    />
  );
}
